"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRemoveCustomerOrderErrorResponse = exports.RemoveCustomerOrderFailedEvent = exports.Name = void 0;
var _failedEventData = require("@ori-events/failed-event-data");
const Name = exports.Name = 'remove-customer-order-failed';
const RemoveCustomerOrderFailedEvent = exports.RemoveCustomerOrderFailedEvent = Name;
const isRemoveCustomerOrderErrorResponse = response => (0, _failedEventData.isErrorResponse)(response);
exports.isRemoveCustomerOrderErrorResponse = isRemoveCustomerOrderErrorResponse;
